export default "__VITE_ASSET__BU14fJaW__"